import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail1Sparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="email-1-sparkle, envelope"><path d="M21.25 12.5V4.75H2.75V19.25H13.5" stroke="currentColor" strokeWidth="1.5"/><path d="M3 5.63623L12 12.9999L21 5.63623" stroke="currentColor" strokeWidth="1.5"/><path d="M19.4 14H18.6L17.6 16.6L15 17.6V18.4L17.6 19.4L18.6 22H19.4L20.4 19.4L23 18.4V17.6L20.4 16.6L19.4 14Z" fill="currentColor"/></CentralIconBase>;
};

export default IconEmail1Sparkle;
